"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PhoneIncomingCallFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_PhoneIncomingCallFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.854.854a.5.5 0 0 0-.708-.708L10 5.293V2a.5.5 0 0 0-1 0v4.5a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 0-1h-3.293L15.854.854Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.667 0h1.778c.981 0 1.777.796 1.777 1.778V3.34c0 .707-.28 1.386-.78 1.886l-.72.719a.882.882 0 0 0-.184 1.002 9.8 9.8 0 0 0 4.516 4.515c.115.056.24.084.364.084a.907.907 0 0 0 .637-.268l.72-.719c.5-.5 1.178-.781 1.886-.781h1.561c.982 0 1.778.796 1.778 1.777v1.779c0 1.44-1.145 2.657-2.585 2.666h-.081C5.964 16 0 10.035 0 2.666 0 1.93.302 1.262.782.782A2.66 2.66 0 0 1 2.667 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_PhoneIncomingCallFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = PhoneIncomingCallFill;
exports["default"] = _default;